import type { IProModalCustomStyles } from "pro-features/components/Modals/src/ProModal";

const ADDON_POPUP = "lnx-93"; // TODO: remove this when cleanup lnx-93-addon-popup test
export const LOCALE_STORAGE_KEY_OPENED_TIME = `${ADDON_POPUP}___variation-displayed-timestamp`;
export const LOCALE_STORAGE_KEY_CLOSED_TIME = `${ADDON_POPUP}___variation-closed-timestamp`;

export const SESSION_STORAGE_KEY_PACKAGE = `${ADDON_POPUP}___package`;

export const DISPLAY_ADDON_POPUP_DELAY = 3000;

export const MORE_USERS_ICON = "/images/addons/addon-popup-more-users.svg";

export const modalCustomStyles: IProModalCustomStyles = {
    content: {
        padding: "12px",
        width: "460px",
        borderRadius: "8px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        border: 0,
    },
};

export const buttonInlineStyle = { width: "300px" };
